import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GlobalsService } from './../globals.service';
import { HttpService } from '../http.service';

import { ScienceCategory } from './science-category';
import { ScienceKeyword } from './science-keyword';
import { ResponseKeyword } from './responseKeyword';

import { TabExpertiseService } from './tab-expertise.service';

const mapCategoryKeyword = new Map<ScienceCategory,ScienceKeyword[]>();

@Component({
    selector: 'app-tab-expertise',
    templateUrl: './tab-expertise.component.html',
    styleUrls: ['./tab-expertise.component.css'],
    standalone: false
})
export class TabExpertiseComponent implements OnInit {
  /**
  * @author dbattist
  * @since Jan 2023
  */

  public sciencecategories : ScienceCategory[] = [];
  public sciencekeywords : ScienceKeyword[] = [];

  public mapCodeSciencekeyword: Map<string,ScienceKeyword> = new Map<string,ScienceKeyword>();
  public mapCodeCategory: Map<string,ScienceCategory> = new Map<string,ScienceCategory>();
  public mapCategoryKeywords : ScienceKeyword[][] = [[],[]];

  public selectedMappedKeywords : boolean[][] = [[],[]];
  public selectedKeywords : ScienceKeyword[] = [];
  public up : boolean[] = [];

  public isSaved : boolean = false;
  public isFetched : boolean = false;
  public userIdFetched : string = "";
  public userIdSaved : string = "";

  constructor(
    private globals: GlobalsService,
    private httpService: HttpService,
    private httpClient: HttpClient,
    private expertiseService: TabExpertiseService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {

    // cleaning text of save button
    this.isSaved = false;
    this.selectedKeywords = [];

    // retrieving all possible categories and keywords
    this.expertiseService.fetchCategories().subscribe(categories => {

      this.sciencecategories = categories;
      this.selectedMappedKeywords = new Array(this.sciencecategories.length).fill(false);
      this.up = new Array(this.sciencecategories.length).fill(false);

      // settings the category and keyword in the data structures
      for(let i = 0; i < this.sciencecategories.length; i++) {
        this.mapCategoryKeywords[i] = this.sciencecategories[i].scienceKeywords;
        this.selectedMappedKeywords[i] = new Array(this.sciencecategories[i].scienceKeywords.length).fill(false);
        const sk : ScienceKeyword[] = this.sciencecategories[i].scienceKeywords;
        for (let j = 0; j < sk.length; j++) {
          this.mapCodeSciencekeyword.set(sk[j].code, sk[j]);
        }
      }

      // retrieving the user expertices
      this.expertiseService.fetchKeywords().subscribe(keys => {
        let resK : ResponseKeyword;
        // marking the experienced checkboxes and expanding their categories panels
        for(let x=0; x<keys.length; x++) {
          resK = (keys[x] as unknown) as ResponseKeyword
          if (this.userIdFetched === "") {
            this.userIdFetched = resK.accountId;
          }
          for (let i=0; i<this.mapCategoryKeywords.length; i++) {
            for (let j = 0; j<this.mapCategoryKeywords.length; j++) {
              if (this.mapCategoryKeywords[i][j].code===resK.keywordCode) {
                this.selectedMappedKeywords[i][j]= true;
                this.selectedKeywords.push(this.mapCodeSciencekeyword.get(resK.keywordCode)!);
                this.up[i]=true;
              }
            }
          }
        }
        this.isFetched = true;
      });
    });

  }

  public save() : void {
    this.isFetched = false;
    this.userIdSaved = this.globals.accountId;
    this.selectedKeywords = [];
    for(let i : number = 0; i < this.mapCategoryKeywords.length; i++) {
      for (let j : number = 0; j < this.mapCategoryKeywords[i].length; j++) {
        if (this.selectedMappedKeywords[i][j] === true) {
          this.selectedKeywords.push(this.mapCategoryKeywords[i][j]);
        }
      }
    }
    this.expertiseService.submitKeywords(this.selectedKeywords).subscribe();
    this.isSaved = true;
  }

  public reset() : void {
    this.isFetched = false;
    this.selectedKeywords = new Array(this.sciencecategories.length).fill(false);
    this.isSaved = false;
    this.up = new Array(this.up.length).fill(false);
  }

  //placeholder
  public buttonPrevious() : void {
    console.log("previous");
  }

  //placeholder
  public buttonNext() : void {
    console.log("next");
  }

  checkExpertise( key : ScienceKeyword) : boolean {
    for(let i = 0; i < this.sciencekeywords.length; i++) {
      if (this.sciencekeywords[i].code === key.code) {
        return true;
      }
    }
    return false;
  }
}
